import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function PracticeBridge() {
  const navigate = useNavigate();
  const location = useLocation();

  const state = (location.state as { source?: string; testId?: string }) || {};
  const testId = state.testId || 'traffic-lights-signals';

  useEffect(() => {
    localStorage.setItem('practiceIntroSeen', 'true');
    navigate(`/practice/${testId}`, { replace: true });
  }, [navigate, testId]);

  return null;
}
